<template>
  <div class="dg" id="download-reports-container">
    <div class="download-reports-modal">
      <div class="download-reports-modal-header">
        <h2 class="title">Download Reports</h2>

        <span class="download-reports-close-btn" @click="close" aria-label="Close modal">
          <i class="fal fa-times"></i>
        </span>
      </div>

      <div class="body">
        <div class="reports-table">
          <div class="repots-table-header">Name</div>

          <div class="report-row">
            <span class="report-name">Payment Report</span>
            <a
              href="#"
              class="download-link"
              :class="{ disabled: downloadingPayment }"
              @click.prevent="downloadFile('payment')"
            >
              <i v-if="downloadingPayment" class="fas fa-spinner fa-spin"></i>
              <span v-else>Download</span>
            </a>
          </div>

          <div class="report-row">
            <span class="report-name">Payout Report</span>
            <a
              href="#"
              class="download-link"
              :class="{ disabled: downloadingPayout }"
              @click.prevent="downloadFile('payout')"
            >
              <i v-if="downloadingPayout" class="fas fa-spinner fa-spin"></i>
              <span v-else>Download</span>
            </a>
          </div>
        </div>
      </div>

      <div class="footer">
        <button
          class="btn-download-all"
          :disabled="downloadingAll"
          @click="downloadAll"
        >
          
          <span><i v-if="downloadingAll" class="fas fa-spinner fa-spin" style="margin-right: 16px;"></i> Download All</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "DownloadReportsModal",
  props: {
    account: {
      type: Object,
      required: true,
      default: () => ({})
    },
    rallyId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
      downloadingPayment: false,
      downloadingPayout: false,
      downloadingAll: false
    };
  },
  methods: {
    ...mapActions("user", ["setModalProps", "flashFailure"]),
    ...mapActions("rfins", ["downloadReport"]),
    close() {
      this.setModalProps({});
    },
    async downloadFile(reportName) {
      if (reportName === "payment") {
        this.downloadingPayment = true;
      } else if (reportName === "payout") {
        this.downloadingPayout = true;
      }

      const accountRallyId = this.account && this.account.attributes ? this.account.attributes["account-rally-id"] : "";
      const accountId = this.account && this.account.attributes ? this.account.attributes["account-id"] : "";
      try {
        const response = await this.downloadReport({
          reportName,
          accountRallyId,
          accountId
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${reportName}_report.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(`Error downloading ${reportName} report:`, error);
        if (!this.downloadingAll) {
          this.flashFailure(`Error downloading ${reportName} report`);
        }
        throw error;
      } finally {
        if (reportName === "payment") {
          this.downloadingPayment = false;
        } else if (reportName === "payout") {
          this.downloadingPayout = false;
        }
      }
    },
    async downloadAll() {
      this.downloadingAll = true;
      try {
        await this.downloadFile("payment");
        await new Promise((resolve) => setTimeout(resolve, 600));
        await this.downloadFile("payout");
      } catch (error) {
        console.error("Error downloading all reports:", error);
        this.flashFailure("Error downloading all reports");
      } finally {
        this.downloadingAll = false;
      }
    }
  }
};
</script>
 